export function isDOMKeyframes(keyframes) {
    return typeof keyframes === "object" && !Array.isArray(keyframes);
}
//# sourceMappingURL=is-dom-keyframes.js.map